module.exports = "/static/media/lineto-circular-black.d1716bac.woff2";